module.exports = __webpack_public_path__ + "img/no-chart-data.161b0bc9.svg";